import gql from 'graphql-tag';
import { REPORT_ITEM_FRAGMENT } from './fragments/reportItem.fragment';

export const PULL_GROUP_ITEMS = gql`
  query GroupItems($input: BPFReportGroupItemsInput!) {
    bpf {
      report {
        result: pullGroupItems(input: $input) {
          error
          success
          entity {
            groupKey

            pagination {
              page
              total
              perPage
              totalPages
            }

            data {
              ...ReportItemFields
            }
          }
        }
      }
    }
  }
  ${REPORT_ITEM_FRAGMENT}
`;
